import Typography from '@mui/material/Typography';

import { NameCell } from '@openx/components-core/lib/NameCell/NameCell';
import { StatusIndicator } from '@openx/components-core/lib/StatusIndicator/StatusIndicator';
import type { Columns } from '@openx/types/tableHelpers';
import type { I18nTranslate } from '@openx/types/translations';
import type { UserList } from '@openx/types/user';

import { DateCell } from './DateCell';

export const getListTableColumns = (t: I18nTranslate, searchPhrase?: string): Columns<UserList> => {
  return [
    {
      ellipsisMaxWidth: '400px',
      key: 'name',
      render: ({ first_name, last_name, id }) => (
        <NameCell name={`${first_name} ${last_name}`} pathTo={`/users/${id}/details`} searchPhrase={searchPhrase} />
      ),
      title: t('Name'),
      width: '22%',
      disabled: true,
    },
    {
      key: 'email_address',
      render: user => <NameCell name={user.email_address} searchPhrase={searchPhrase} disableBoldName={false} />,
      title: t('Email'),
      width: '23%',
    },
    {
      key: 'role',
      render: user => user.role || null,
      title: t('Role'),
      width: '10%',
    },
    {
      key: 'account',
      render: ({ account }) => (account ? account.name : null),
      title: t('Organization'),
      width: '15%',
    },
    {
      key: 'status',
      render: user => {
        const statusIndicatorProps = user.is_active
          ? { label: 'Active', status: 'active' }
          : { label: 'Inactive', status: 'inactive' };
        return <StatusIndicator {...statusIndicatorProps} />;
      },
      title: t('Status'),
      width: '10%',
    },
    {
      key: 'last_signin_time',
      render: ({ last_signin_time }) =>
        last_signin_time ? <DateCell date={last_signin_time} /> : <Typography component="span">N / A</Typography>,
      title: t('Last Login'),
      width: '10%',
    },
    {
      key: 'created_date',
      render: ({ created_date }) => <DateCell date={created_date} />,
      title: t('Date Joined'),
      width: '10%',
    },
  ];
};
